import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import { closeModal, deleteCampaign, gotoUrl } from "../../actions";

export class DeleteCampaignModal extends Component {
  constructor(props) {
    super(props);
    this.delete = this.delete.bind(this);
  }

  delete(e) {
    if (e) {
      e.preventDefault();
    }

    const { accountId, id } = this.props;

    this.props.deleteCampaign(accountId, id).then(this.props.closeModal);
  }

  render() {
    const { campaign } = this.props;

    return (
      <Modal>
        <ModalHeader>Delete Folder?</ModalHeader>
        <ModalContent>
          Remove {(campaign && campaign.name) || "Folder"}?
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          <Button onClick={this.delete}>Delete</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

DeleteCampaignModal.propTypes = {
  deleteCampaign: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const { accountId, id } = params;
  const campaign = state.entities.campaign[id];

  return {
    accountId,
    id,
    campaign,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  deleteCampaign,
  gotoUrl,
})(DeleteCampaignModal);
